const BusinessHours = () => {
  const isOpenNow = () => {
    const now = new Date();
    const day = now.getDay(); // 0 = Sunday, 6 = Saturday
    const hour = now.getHours();
    const minute = now.getMinutes();

    const timeInMinutes = hour * 60 + minute;

    const schedule = {
      weekday: { open: 9 * 60, close: 21 * 60 }, // 9:00 AM - 9:00 PM
      weekend: { open: 10 * 60, close: 22 * 60 }, // 10:00 AM - 10:00 PM
    };

    const isWeekend = day === 0 || day === 6;
    const { open, close } = isWeekend ? schedule.weekend : schedule.weekday;

    return timeInMinutes >= open && timeInMinutes <= close;
  };

  return (
    <div className="mt-4 pt-4 border-t border-gray-200/50">
      <div className="flex items-center justify-end">
        <div className="text-right">
          <p className="text-xs text-gray-600">
            Mon-Fri: 9AM–9PM
            <br />
            Sat-Sun: 10AM–10PM
          </p>
          <p className={`text-xs mt-3 font-medium ${isOpenNow() ? 'text-green-600' : 'text-red-500'}`}>
            ● {isOpenNow() ? 'We are Open' : 'Sorry, We are Close'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessHours;
